import React, { useState } from "react";

function Login({ onLogin }) {
  const [pseudo, setPseudo] = useState("");

  const handleLogin = () => {
    if (!pseudo.trim()) return;

    localStorage.setItem("username", pseudo);
    onLogin(pseudo);
  };

  return (
    <div className="login-box">
      <h3>Entre ton pseudo 🎮</h3>
      <input
        type="text"
        placeholder="Ton pseudo"
        value={pseudo}
        onChange={(e) => setPseudo(e.target.value)}
      />
      <button onClick={handleLogin}>
        Se connecter
      </button>
    </div>
  );
}

export default Login;